import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterKapsalonPage() {
  return <ClusterPageTemplate clusterName="Kapsalon" sectorName="Lokale Retail & Dienstverlening" sectorSlug="lokale-retail" heroTitle="Website laten maken voor een kapsalon" heroDescription="Een stijlvolle, moderne website voor jouw kapsalon, barbershop of beautysalon. Wij bouwen websites die jouw creativiteit tonen en de agenda vullen." websiteOnderdelen={[{
    icon: 'ScissorsIcon',
    title: 'Behandelingen & Prijzen',
    description: 'Een overzichtelijke prijslijst voor knippen, kleuren, stylen en andere beautybehandelingen.'
  }, {
    icon: 'CameraIcon',
    title: 'Lookbook / Portfolio',
    description: 'Laat je beste werk zien met een visuele galerij van kapsels, kleuringen en transformaties.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Online boeken',
    description: 'Een prominente knop op elke pagina waarmee klanten direct een afspraak kunnen inplannen.'
  }, {
    icon: 'UsersIcon',
    title: 'Het Team',
    description: 'Stel je stylisten voor. Klanten boeken vaak specifiek bij hun favoriete kapper.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Boekingssysteem',
    description: 'Naadloze integratie met kapperssoftware zoals Salonized, Barberbooking of Treatwell.'
  }, {
    icon: 'StarIcon',
    title: 'Instagram koppeling',
    description: 'Toon automatisch je nieuwste creaties direct vanuit je Instagram feed op de website.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale vindbaarheid',
    description: 'Zorg dat je salon bovenaan staat wanneer mensen in de buurt zoeken naar een kapper.'
  }]} siblingClusters={[{
    name: 'Fietsenwinkel',
    slug: 'fietsenwinkel'
  }, {
    name: 'Garage',
    slug: 'garage'
  }, {
    name: 'Autobedrijf',
    slug: 'autobedrijf'
  }]} faqs={[{
    q: 'Werkt de website goed samen met Salonized?',
    a: 'Ja, we integreren de boekingswidget van Salonized (of vergelijkbare systemen) perfect in het design, zodat klanten de site niet hoeven te verlaten om te boeken.'
  }, {
    q: 'Kan ik zelf de prijslijst aanpassen?',
    a: 'Zeker. We bouwen een eenvoudig systeem in WordPress waarmee je zelf prijzen kunt updaten of nieuwe behandelingen kunt toevoegen.'
  }, {
    q: 'Wat kost een website voor een kapsalon?',
    a: 'Een stijlvolle, lokaal vindbare website voor een salon start vanaf €1.500. Dit is inclusief de integratie van je boekingssysteem.'
  }, {
    q: 'Is de website goed te gebruiken op een mobiele telefoon?',
    a: 'Absoluut. Bijna al je klanten zullen via hun mobiel de website bezoeken om een afspraak te maken. Onze websites zijn 100% mobile-first.'
  }]} data-id="element-1084" />;
}